export default (value) => {
  if (typeof value === "string") {
    return !isNaN(Number(value)) ? value.replace(/\./g, "") : 0;
  } else if (typeof value === "number") {
    return !isNaN(value) ? String(value).replace(/\./g, "") : 0;
  } else {
    return 0;
  }
};
